export enum KeySuffixOptions {
  Auto = "auto",
  Biometric = "biometric",
}
